// extracted by mini-css-extract-plugin
export default {"padding":"Request_padding__IhOXy","heading":"Request_heading__r3Sur"};